var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "20 20 40 28"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 28,
    x: 20,
    y: 20,
    fill: "#fff",
    rx: 14
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#172B85",
    fillRule: "evenodd",
    d: "M32.143 38.968H29.72l-1.817-7.077c-.086-.325-.27-.613-.539-.749a7.8 7.8 0 0 0-2.22-.749v-.272h3.903c.538 0 .942.41 1.01.885L31 36.11l2.422-5.99h2.356zm4.982 0h-2.289l1.885-8.847h2.288zm4.845-6.396c.067-.477.471-.75.943-.75a4.2 4.2 0 0 1 2.22.409l.405-1.905a5.7 5.7 0 0 0-2.087-.41c-2.221 0-3.837 1.226-3.837 2.927 0 1.294 1.145 1.973 1.953 2.383.874.408 1.21.68 1.143 1.088 0 .612-.673.885-1.345.885-.808 0-1.617-.204-2.356-.545l-.404 1.906c.808.34 1.682.476 2.49.476 2.49.068 4.039-1.157 4.039-2.994 0-2.314-3.164-2.45-3.164-3.47m11.173 6.396-1.817-8.847h-1.952c-.404 0-.808.272-.943.68l-3.365 8.167h2.356l.47-1.293h2.895l.27 1.293zm-3.432-6.465.672 3.335H48.5z",
    clipRule: "evenodd"
  })));
};
export default SvgVisa;